export const GET_MENUS = "GET_MENUS";
export const INIT_MENUS = "SET_MENUS";
export const SET_ROUTERS = "SET_ROUTERS";
export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
